import React from "react";
import { Search, PenSquare, Pin, Users, X, Maximize2, Minimize2, Sparkles } from "lucide-react";
import Avatar from "./Avatar";
import { useChat } from "./chatStore";
import styles from "./chat.module.scss";

const fmtTime = (ts) => {
  if (!ts) return "";
  const d = new Date(ts);
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const sameDay = d.toDateString() === now.toDateString();
  if (sameDay) return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  const yest = new Date(now);
  yest.setDate(now.getDate() - 1);
  if (d.toDateString() === yest.toDateString()) return "Dün";
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}`;
};

const ConversationList = ({ onClose }) => {
  const {
    conversations,
    activeId,
    setActive,
    query,
    setQuery,
    unreadOf,
    lastMsg,
    openNewChat,
    togglePin,
    expanded,
    toggleExpand,
  } = useChat();

  return (
    <div className={styles.listPane}>
      <header className={styles.listHeader}>
        <h2 className={styles.listTitle}>Mesajlar</h2>
        <div className={styles.listHeaderActions}>
          <button
            type="button"
            className={styles.iconBtn}
            onClick={openNewChat}
            title="Yeni sohbet"
            aria-label="Yeni sohbet"
          >
            <PenSquare size={18} />
          </button>
          {/* Genişlet/küçült — yalnız desktop (overlay). Tam ekranı kaplar. */}
          <button
            type="button"
            className={`${styles.iconBtn} ${styles.iconBtnExpand}`}
            onClick={toggleExpand}
            title={expanded ? "Küçült" : "Tam ekran"}
            aria-label={expanded ? "Küçült" : "Tam ekran"}
          >
            {expanded ? <Minimize2 size={17} /> : <Maximize2 size={17} />}
          </button>
          {onClose && (
            <button
              type="button"
              className={`${styles.iconBtn} ${styles.iconBtnClose}`}
              onClick={onClose}
              title="Kapat"
              aria-label="Kapat"
            >
              <X size={18} />
            </button>
          )}
        </div>
      </header>

      <div className={styles.searchWrap}>
        <Search size={16} className={styles.searchIcon} />
        <input
          className={styles.searchInput}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Sohbet ara"
          type="text"
        />
        {query && (
          <button
            type="button"
            className={styles.searchClear}
            onClick={() => setQuery("")}
            aria-label="Temizle"
          >
            <X size={14} />
          </button>
        )}
      </div>

      <div className={styles.convScroll}>
        {conversations.length === 0 ? (
          <div className={styles.listEmpty}>
            <p>Sohbet bulunamadı.</p>
            <button type="button" className={styles.linkBtn} onClick={openNewChat}>
              Yeni sohbet başlat
            </button>
          </div>
        ) : (
          conversations.map((c) => {
            const last = lastMsg(c);
            const unread = unreadOf(c);
            const mineLast = last?.authorId === "me";
            const preview = last
              ? `${mineLast ? "Sen: " : ""}${last.text || (last.attachments?.length ? "📎 Ek" : "")}`
              : "Henüz mesaj yok";
            return (
              <button
                key={c.id}
                type="button"
                className={`${styles.convRow} ${activeId === c.id ? styles.convRowActive : ""} ${
                  unread ? styles.convRowUnread : ""
                }`}
                onClick={() => setActive(c.id)}
              >
                <Avatar
                  src={c.avatar}
                  name={c.displayName}
                  initials={c.initials}
                  color={c.color}
                  size={46}
                  online={c.type === "dm"}
                  square={c.type === "group"}
                  icon={
                    c.type === "group" ? (
                      <Users size={20} />
                    ) : c.type === "ai" ? (
                      <Sparkles size={20} />
                    ) : null
                  }
                />
                <span className={styles.convBody}>
                  <span className={styles.convTop}>
                    <span className={styles.convName}>
                      {c.type === "group" && (
                        <span className={styles.groupTag}>
                          <Users size={11} /> GRUP
                        </span>
                      )}
                      {c.displayName}
                    </span>
                    <span className={styles.convTime}>{fmtTime(last?.createdAt)}</span>
                  </span>
                  <span className={styles.convBottom}>
                    <span className={styles.convSnippet}>{preview}</span>
                    {unread > 0 ? (
                      <span className={styles.convBadge}>{unread}</span>
                    ) : c.pinned ? (
                      <Pin size={13} className={styles.convPin} />
                    ) : null}
                  </span>
                </span>
                <span
                  className={styles.convPinBtn}
                  role="button"
                  tabIndex={-1}
                  title={c.pinned ? "Sabitlemeyi kaldır" : "Sabitle"}
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePin(c.id);
                  }}
                >
                  <Pin size={14} />
                </span>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ConversationList;
